/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { Guard } from './Guard';
import { DefaultGuardModel } from './DefaultGuardModel';

export class GuardContextValue {
    constructor(public guard: Guard = new Guard(new DefaultGuardModel(), [], {})) {}
}

export const GuardContext = React.createContext(new GuardContextValue());
export const GuardResourceContext = React.createContext({ resourceName: '' });
